import React from 'react';

const Message = () => {
    return (
        <div style={{letterSpacing: '5px', backgroundColor: '#34495e', color: '#fff'}} className="message font-weight-bold text-center p-2">
            Human Lives Matter
        </div>
    );
};

export default Message;